import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
let serverUrl = getSecret('SERVER_URL');
import i18n from '@plugins/i18n'

export const getters = {
  getStakeholderFields() {
    return {model: 'repositories_stakeholders', 
            label: 'Stakeholders',
            fields: [
                { key: 'name', label: 'Name', type: 'text', sortable: true, required: true },
                { key: 'description', label: 'Description', type: 'text', sortable: true, required: false },
                { key: 'category', label: 'Categories', type: 'array_model', 
                  model_source: 'Categories', model_route: 'management/masters/categories', 
                  sortable: true, required: true,
                  formatter: (value, key, item) => {
                    return item.category.length}
                }
              ]}
  },
}


export const actions = {
  async fetchStakeholders(context, query = '') {
    return axios
      .get(`${serverUrl}/api/masters/stakeholders/${query}`)
      .then((response) => {
        return response.data;
      })
  },

  async createStakeholders(context, { payload }) {
    return axios
      .post(`${serverUrl}/api/masters/stakeholders/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async updateStakeholders(context, { payload }) {
    return axios
      .patch(`${serverUrl}/api/masters/stakeholders/${payload.id}/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async deleteStakeholders(context, { id }) {
    return axios
      .delete(`${serverUrl}/api/masters/stakeholders/${id}/`)
      .then((response) => {
        return response.data;
      })
  },
}